import { useFeatureFlagPayload, usePostHog } from "posthog-js/react";
import { useCallback, useEffect, useState } from "react";
import { ORDER_FORM_V2_FLAG } from "../orderFormV2Flag";

/**
 * Product types enabled in the V2 order flow, from the `order_form_v2`
 * PostHog flag payload (e.g. ["BRIDGE", "VENEER"]).
 *
 */
export const useV2ProductTypes = () => {
  const posthog = usePostHog();
  const payload = useFeatureFlagPayload(ORDER_FORM_V2_FLAG) as
    string[] | undefined | null;

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => posthog.onFeatureFlags(() => setIsLoading(false)), [posthog]);

  const v2ProductTypes = payload ?? [];

  const isV2Product = useCallback(
    (type: string | null | undefined): boolean =>
      !!type && !!payload?.includes(type),
    [payload]
  );

  return { v2ProductTypes, isV2Product, isLoading };
};
